<template>
    <div>
        <h3 class="text-center mb-3">Editar Contraseña del Estudiante</h3>
        <b-row class="my-3">
            <b-col cols="6" md="9">
                <b-button
                    variant="info"
                    class="mx-2"
                    :to="{ name: 'admin-students-edit', params: { studentIdCardNumber: form.idCardNumber }}"
                >
                    <b-icon-arrow-bar-left /> Atrás
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <strong>Atención:</strong>
                ¡Esta función sobrescribirá la contraseña actual del estudiante! Usar con cautela.
                <b-form
                    @submit.stop.prevent="onSubmit"
                    class="mt-4"
                >
                    <b-row>
                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <b-form-group
                                id="input-group-password"
                                label="*Nueva contraseña:"
                                label-for="input-password"
                            >
                                <b-form-input
                                    id="input-password"
                                    v-model="$v.form.password.$model"
                                    type="password"
                                    required
                                    :disabled="formDisabled"
                                    :state="validateState('password')"
                                />
                                <b-form-invalid-feedback id="input-password-feedback">
                                    Este campo es requerido y debe tener un mínimo de 6 caracteres.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            lg="6"
                        >
                            <b-form-group
                                id="input-group-confirm"
                                label="*Repetir contraseña:"
                                label-for="input-confirm"
                            >
                                <b-form-input
                                    id="input-confirm"
                                    v-model="$v.form.confirm.$model"
                                    type="password"
                                    required
                                    :disabled="formDisabled"
                                    :state="validateState('confirm')"
                                />
                                <b-form-invalid-feedback id="input-confirm-feedback">
                                    Este campo es requerido y debe ser igual a la contraseña.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <div class="text-center float-right">
                        <b-button
                            type="submit"
                            variant="warning"
                            size="lg"
                            :disabled="formDisabled || $v.form.$invalid"
                        >
                            Cambiar
                        </b-button>
                    </div>

                </b-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
    name: 'AdminStudentsEditPassword',
    data () {
        return {
            formDisabled: false,
            form: {
                idCardNumber: '',
                password: '',
                confirm: ''
            }
        }
    },
    validations: {
        form: {
            password: {
                required,
                minLen: minLength(6)
            },
            confirm: {
                required,
                sameAs: sameAs('password')
            }
        }
    },
    watch: {
        async '$route' (to, from) {
            this.form.idCardNumber = to.params.studentIdCardNumber
        }
    },
    methods: {
        ...mapActions([
            'editStudentPassword'
        ]),
        // TODO: Refactor this method into a ValidatedFormMixin
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onSubmit () {
            let loader = null
            // Create a const copy
            const payloadData = JSON.parse(JSON.stringify(this.form))
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                await this.editStudentPassword(payloadData)
                this.$root.successToast(`La contraseña del estudiante ha sido editada exitosamente.`)
                this.$router.replace({ name: 'admin-students-list' })
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    },
    mounted () {
        this.form.idCardNumber = this.$route.params.studentIdCardNumber
    }
}
</script>
